import {getRequest, postRequest, putRequest} from "@/api/http";

// 获取图形验证码
export const getSmsCodeImg = (smsPhone) => getRequest("/smsAuth/sendAuthCode/" + smsPhone);

// 获取图形验证码
export const getCodeImg = () => getRequest("/captchaImage");
// 登录
export const loginAccount = (data) => postRequest("/login", data);
export const login = (data) => postRequest("/loginWithSmsCode", data);
export const updateUserPwd = (data) => putRequest("/system/user/profile/updatePwd", data);
// 用户密码重置
// 获取用户详细信息
export const getUserInfo = (data) => getRequest("/getInfo", data);

// 公共模块
export const getDicts = (dictType) => getRequest("/system/dict/data/type/" + dictType);// 根据字典类型查询字典数据信息


// 病例管理/订单管理
export const listMedicalOrder = (data) => getRequest("/buz/medicalOrder/listForAll", data); // 查询工单信息列表
export const getMedicalOrderDetail = (orderId) => getRequest("/buz/medicalOrder/detail/" + orderId); // 查询工单信息详细 包含所有信息
export const getMiniOrderIdentityReservations = (orderId) => getRequest("/buz/medicalOrder/" + orderId + "/identity-reservations");
export const bindMiniPatientIdentity = (data) => putRequest("/buz/medicalOrder/bindMiniPatientIdentity", data);
export const getMedicalOrderPaymentReceipt = (orderId) => getRequest("/buz/medicalOrder/" + orderId + "/payment-receipt"); // 查询已支付订单付款凭条
export const confirmMedicalOrderCashPayment = (orderId) => postRequest("/buz/medicalOrder/" + orderId + "/cash-payment"); // 门诊订单现金收款
export const getPatientListByName = (searchKey) => getRequest("/buz/docPatientProfile/listAllNameList/"+ searchKey);
export const clinicSqbOrderPay = (data) => postRequest("/sqbOrderPay/create", data); // 药品订单收钱吧付款码收款
// autoPoll=true 表示 pending 弹窗的自动轮询（区别于收银员手动点击）：后端据此区分留痕来源
export const clinicSqbQueryResult = (orderId, autoPoll) => getRequest("/sqbOrderPay/queryResult", {orderId, autoPoll}); // 重新查询工单收款结果（只读，不发起扣款）
export const clinicSqbTreatmentPay = (data) => postRequest("/sqbTreatmentPay/create", data); // 检查治疗订单收钱吧付款码收款
export const clinicSqbTreatQueryResult = (orderId, autoPoll) => getRequest("/sqbTreatmentPay/queryResult", {orderId, autoPoll}); // 重新查询检查治疗单收款结果（只读，不发起扣款；autoPoll 同 clinicSqbQueryResult）
export const getTreatOrderPaymentReceipt = (orderId) => getRequest("/buz/treatOrder/" + orderId + "/payment-receipt"); // 查询已支付检查治疗订单付款凭证

// 统计分析
export const getColumnData = (startTime,endTime,data) => getRequest("/buz/docStat/getColumnData/" + startTime+"/"+endTime, data);
export const getServerData = (startTime,endTime, data) => getRequest("/buz/docStat/getServerData/" + startTime+"/"+endTime, data);

export const listMedicineDecoction = (dictType, data) => getRequest("/system/dict/data/type/" + dictType, data);// 分类查询药品

// 查询检查治疗订单所有列表
export const getTreatOrderAllList = (data) => getRequest("/buz/treatOrder/listAll", data);
// 查询检查治疗订单列表_子列表
export const getTreatOrderItemList = (data) => getRequest("/buz/treatOrderItem/list", data);

// 执行检查治疗项目
export const executetreatOrderItem = (toId) => putRequest("/buz/treatOrderItem/executeItem/" + toId); // 查询常用处方详细

// 预约管理
export const getReservationList = (data) => getRequest("/buz/patientReservation/list", data);
// 同一端点的别名（预约管理/今日预约共用），别再单独定义第二个请求函数，避免两边行为漂移
export const getTodayReservationList = getReservationList;
export const signReOrder = (reId) => putRequest("/buz/patientReservation/signReOrder/"+reId); // 签到
export const getTodayReservationStat = (data) => getRequest("/buz/patientReservation/todayReservationStat", data); // 今日预约统计
export const getUnifiedClinicQueue = (data) => getRequest("/buz/patientReservation/unified-queue", data);
export const registerOnsiteFree = (data) => postRequest("/buz/patientReservation/onsite-free", data);
export const registerOnsitePaid = (data) => postRequest("/buz/patientReservation/onsite-paid", data); // 现场付费挂号：创建待支付挂号单
export const cancelOnsitePaid = (reId) => putRequest("/buz/patientReservation/onsite-cancel/" + reId); // 取消未支付的现场付费挂号单
export const clinicSqbReservationPay = (data) => postRequest("/sqbReservationPay/create", data); // 现场付费挂号收钱吧付款码收款
export const clinicSqbReservationQueryResult = (reId, autoPoll) => getRequest("/sqbReservationPay/queryResult", {reId, autoPoll}); // 重新查询现场挂号收款结果（只读，不发起扣款；autoPoll 同 clinicSqbQueryResult）
export const getOnsiteSchedules = (data) => getRequest("/buz/patientReservation/onsite-schedules", data); // 现场挂号可选的当天排班
export const searchReservationPatients = (keyword) => getRequest("/buz/patientReservation/patient-search", {keyword}); // 现场挂号：按姓名/手机号搜索已有患者档案
export const matchReservationPatient = (identity) => getRequest("/buz/patientReservation/onsite-patient-match", {identity}); // 现场挂号：手填身份证预检查，返回匹配到的已有档案（只查不建）
export const registerReturnVisit = (reId) => postRequest("/buz/patientReservation/" + reId + "/return-visit"); // 回诊登记
export const completeReturnVisit = (returnId) => putRequest("/buz/patientReservation/return-visit/" + returnId + "/complete");
export const cancelReturnVisit = (returnId) => putRequest("/buz/patientReservation/return-visit/" + returnId + "/cancel");

